import(/* webpackMode: "eager" */ "/vercel/path1/app/vocab/study/page.tsx");
